import { v4 as uuidv4 } from 'uuid'
import {
  EMP_CHECK_LIST_NEW,
  EMP_CHECK_LIST_RESIGN,
  EMP_MONTHLY_APPOINT,
  EMP_MONTHLY_HBD,
  EMP_MONTHLY_NEW,
  EMP_MONTHLY_RESIGNS,
  EMP_TRANSFER,
  EMP_TRANSFER_ORG,
  PAGE_REPORT_APPOINT,
  PAGE_REPORT_BIRTHDAY,
  PAGE_REPORT_LOAN_HOME,
  PAGE_REPORT_NEW,
  PAGE_REPORT_RESIGN,
  PIM_EMP_INFO,
  PIM_EMP_PERSONAL_PROFILE,
  PIM_EMP_PROPERTY,
  PIM_EMP_WELFARE
} from '../../../router/routes'
import fnSubCardMenu from './map-cardList'

export default function fnCardMenu(d) {
  const fnSetObj = (link, subList = []) => {
    return {
      menuId: d.id,
      id: uuidv4(),
      label: d.card_name,
      link,
      key: d.id,
      icon: null,
      menuSubList: subList
    }
  }

  switch (d.id) {
    // Checklist New Employee
    case 1:
      return fnSetObj(EMP_CHECK_LIST_NEW)

    //  Checklist Resign Employee
    case 2:
      return fnSetObj(EMP_CHECK_LIST_RESIGN)

    case 3:
      return fnSetObj(EMP_MONTHLY_NEW)

    //   Resign Employee
    case 4:
      return fnSetObj(EMP_MONTHLY_RESIGNS)

    //   Employment
    case 5:
      return fnSetObj(EMP_MONTHLY_APPOINT)

    //   Birthday
    case 6:
      return fnSetObj(EMP_MONTHLY_HBD)

    // Employee Info
    case 7:
      return fnSetObj(
        PIM_EMP_INFO,
        d.card_list && d.card_list.length > 0
          ? d.card_list.map((c, i) => {
              return fnSubCardMenu(c)
            })
          : []
      )

    // Personal Profile
    case 8:
      return fnSetObj(PIM_EMP_PERSONAL_PROFILE)

    // Welfare
    case 9:
      return fnSetObj(PIM_EMP_WELFARE)
    //   Property Info
    case 10:
      return fnSetObj(PIM_EMP_PROPERTY)

    // promote
    case 11:
      return fnSetObj(EMP_TRANSFER)

    // transfer org
    case 12:
      return fnSetObj(EMP_TRANSFER_ORG)

    // report new
    case 13:
      return fnSetObj(PAGE_REPORT_NEW)

    // report resign
    case 14:
      return fnSetObj(PAGE_REPORT_RESIGN)

    // report appoint
    case 15:
      return fnSetObj(PAGE_REPORT_APPOINT)
    // report birthday
    case 16:
      return fnSetObj(PAGE_REPORT_BIRTHDAY)

    default:
      break
  }
}
